import { render } from "./incomeStatistics.vue?vue&type=template&id=04361013&scoped=true"
import script from "./incomeStatistics.vue?vue&type=script&lang=js"
export * from "./incomeStatistics.vue?vue&type=script&lang=js"

import "./incomeStatistics.vue?vue&type=style&index=0&id=04361013&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-04361013"

export default script